import React from 'react'
import {ContentHotel} from '@findhotel/sapi'
import {LocationDetails} from 'components/HotelCardLocationDetails'
import {HotelType} from 'types/Hotel'
import {Spacing} from 'types/Theme'
import {imageProvider} from 'utils/imageProvider'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {Image} from '@vio/atlas/Image'
import {StarRating} from '@vio/atlas/StarRating'
import {ReviewRating} from '@vio/shared/src/search/ReviewRating'

import {BEST_DEAL_IMAGE_HEIGHT} from './styles'
import {
  ExitPopupContentWrapper,
  HotelName,
  ImageWrapper,
  StarRatingWrapper
} from './styles'

interface Props {
  hotel: ContentHotel | HotelType
  paddingTop?: Spacing
  paddingRight?: Spacing
  paddingLeft?: Spacing
  paddingBottom?: Spacing
}
export const ExitPopupContent = ({
  hotel,
  paddingTop,
  paddingLeft,
  paddingRight,
  paddingBottom
}: Props) => {
  const imageURL = hotel?.imageURIs[0] ?? ''
  const {isMobile} = useDeviceLayout()

  return (
    <ExitPopupContentWrapper
      paddingTop={paddingTop}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
      paddingBottom={paddingBottom}
    >
      <ImageWrapper>
        <Image
          isResponsive
          hasSkeletonLoader
          size={isMobile ? 'mobileLarge' : 'extraLarge'}
          url={imageURL}
          borderRadius="lg"
          height={BEST_DEAL_IMAGE_HEIGHT}
          imageProvider={imageProvider}
        />
      </ImageWrapper>
      <StarRatingWrapper data-id="StarRating">
        <StarRating size="xs" rating={hotel.starRating} />
      </StarRatingWrapper>
      <Box display="flex" justifyContent="space-between" gap="s400">
        <Box flex="1">
          <HotelName data-id="HotelName" dir="auto">
            {hotel.hotelName}
          </HotelName>
          <LocationDetails placeName={hotel.placeDisplayName} />
        </Box>
        <ReviewRating
          rating={hotel?.guestRating.overall}
          totalRatingCount={hotel.reviewCount}
          hotelId={hotel.objectID}
        />
      </Box>
    </ExitPopupContentWrapper>
  )
}
